<template>
  <div id="FeedbackTextArea">
    <div class="feedback-confirm-container w-100">
      <textarea
        v-model="answerText"
        @input="filterInput"
        class="feedback-confirm-input"
        rows="4"
        :maxlength="maxLength"
        placeholder="Enter text here"
      />
    </div>
    <span class="characters">{{maxLength - answerText.length}} Characters remaining</span>
  </div>
</template>

<script>
export default {
  name: "FeedbackTextArea",
  props: ["question", "answer", "setAnswer"],
  data() {
    return {
      answerText: this.answer.comment || "",
      maxLength: this.question.characterLimit || 300
    };
  },
  mounted() {
    this.answerText = this.answer.comment || "";
  },
  methods: {
    filterInput(event) {
      this.answerText = event.target.value.replace(/[^a-zA-Z0-9 .,@!?'()]/g, "");
    }
  },
  watch: {
    answer(newAnswer) {
      this.answerText = newAnswer || "";
    },
    answerText(newText) {
      this.setAnswer(newText, "comment");
    }
  }
};
</script>
<style lang="less">
#FeedbackTextArea {
  .feedback-confirm-container {
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #aeb0bd;
    padding: 15px;
    margin-bottom: 20px;
    
    .feedback-confirm-input {
      font-family: "DMSans";
      font-size: 1.6rem;
    }
    
    textarea {
      background: #ffffff;
      border: none;
      width: 100%;
    }
    
    textarea:focus {
      outline-width: 0;
    }
  }
  
  .characters {
    color: #1e1e22;
    font-size: 16px;
    font-family: "DMSans";
  }
  
  .feedback-confirm-container:focus-within {
    border-color: #1e1e22 !important;
  }
}
</style>
